import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Query } from 'src/app/models/Query';
import { QueryService } from 'src/app/queries/queries.service';

import { VeldaArticlesState } from '../../velda-articles.state';

@Component({
    selector: 'app-velda-articles-sets-list',
    templateUrl: './velda-articles-sets-list.component.html',
    styleUrls: ['./velda-articles-sets-list.component.scss'],
})
export class VeldaArticlesSetsListComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(VeldaArticlesState.queries) queries$: Observable<Query[]>;

    query: Query;
    data: any[];
    loading = true;
    queryError = false;

    constructor(private queryService: QueryService, private store: Store) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.queries$.subscribe((queries) => {
                this.query = queries?.find((q) => q?.type === 'SETS');
                this.queryService.runQueryByType('SETS').subscribe((res) => {
                    if (JSON.parse(JSON.stringify(res)).errors) {
                        this.queryError = true;
                    } else {
                        this.queryError = false;
                        this.data = JSON.parse(JSON.stringify(res)).data.entries;
                    }
                });
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
